import { getSharedIconBoxStyle } from './shared-icon-box-style';

export const getInfoPaneItemExternalLinkStyle = (components, { palette = {}, iconFontFamily = 'MsAds MDL2 Assets' } = {}) => ({
  container: {
    ...getSharedIconBoxStyle({ palette }),
  },
  linkIcon: {
    fontFamily: iconFontFamily,
    fontSize: 16,
    marginRight: 8,
    color: palette.blue,
    '&:before': {
      content: '"\\E8A7"',
    },
  },
  linkText: {
    fontFamily: 'Segoe UI',
    fontWeight: 400,
    fontSize: 14,
    lineHeight: '20px',
  },
});
